export default {
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	data() {
		return {
			applicationStatuses: [
				{name: "Created", value: "Created"},
				{name: "Submitted", value: "Submitted"},
				{name: "Rejected", value: "Rejected"},
				{name: "Accepted", value: "Accepted"},
				{name: "Finalised", value: "Finalised"},
				{name: "Consolidated", value: "Consolidated"},
			],
			rpkApplicationStatuses: [
				{name: "Created", value: "Created"},
				{name: "Submitted", value: "Submitted"},
				{name: "Rejected", value: "Rejected"},
				{name: "Accepted", value: "Accepted"},
			],
			cwkApplicationStatuses: [
				{name: "Created", value: "Created"},
				{name: "Finalised", value: "Finalised"},
			],
			journalApplicationStatuses: [
				{name: "Created", value: "Created"},
				{name: "Consolidated", value: "Consolidated"},
			],
		}
	}
};